// src/hooks/audience/useDomainActions.js
import { useCallback, useState } from "react";
import Api from "../../utils/Api";
import {
  API_ROUTE_AUDIENCE_CLASSIFICATION_MAP,
  API_ROUTE_AUDIENCE_CLASSIFICATION_REJECT,
} from "../../routes";

export function useDomainActions() {
  const [actionLoading, setActionLoading] = useState(false);
  const [actionError, setActionError] = useState("");

  const mapDomain = useCallback(async (domainId, titleId, userId) => {
    setActionLoading(true);
    setActionError("");
    try {
      await Api.put(
        API_ROUTE_AUDIENCE_CLASSIFICATION_MAP.replace("{id}", domainId),
        {
          titleId,
          userId,
        },
      );
      return true;
    } catch (err) {
      setActionError(
        err?.response?.data?.message || err?.message || "Failed to map domain.",
      );
      return false;
    } finally {
      setActionLoading(false);
    }
  }, []);

  const rejectDomain = useCallback(async (domainId, userId) => {
    setActionLoading(true);
    setActionError("");
    try {
      await Api.put(
        API_ROUTE_AUDIENCE_CLASSIFICATION_REJECT.replace("{id}", domainId),
        {
          userId,
        },
      );
      return true;
    } catch (err) {
      setActionError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to reject domain.",
      );
      return false;
    } finally {
      setActionLoading(false);
    }
  }, []);

  return {
    actionLoading,
    actionError,
    setActionError,
    mapDomain,
    rejectDomain,
  };
}
